@if(isLoading) {
  <mat-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-spinner>
} @else if (configuration) {
  @if (!versionDetail) {
    <app-card [inCardTitle]="configuration.name"
              icon="arrow_back"
              (iconClicked)="navigateBack()">
      <div *appCardContent>
        <table
          mat-table
          [dataSource]="dataSource"
          class="ops-table"
        >
          <ng-container matColumnDef="saved">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="mat-body text-accent"
            >
              Saved
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.created | date: 'yy-MM-dd HH:mm:ss' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="changedBy">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="mat-body text-accent"
            >
              Changed By
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.changedBy }}
            </td>
          </ng-container>
          <ng-container matColumnDef="note">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="mat-body text-accent"
            >
              Note
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.note }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="showVersionDetail(row)">
          </tr>
        </table>
      </div>
    </app-card>
  } @else {
    <app-card [inCardTitle]="configuration.name + ' | ' + (versionDetail.created | date:'yy-MM-dd HH:mm:ss')"
              icon="arrow_back"
              (iconClicked)="backToVersionList()">
      <div *appCardContent>
        @if (versionDetail.changes.configuration) {
          <app-route-configuration-changes
            [configurationChanges]="versionDetail.changes.configuration">
          </app-route-configuration-changes>
        } @else if (versionDetail.changes.geometry) {
          <app-route-geometry-changes
            [geometryChanges]="versionDetail.changes.geometry">
          </app-route-geometry-changes>
        }
      </div>
    </app-card>
  }
} @else {
  <span>Error</span>
}
